export const tablesQueryKeys = {
  tables: ['tables'] as const,
  capabilities: ['tables', 'capabilities'] as const,
  tableSchema: (tableId: string) => ['tables', tableId, 'schema'] as const,
}
